import React, { Component } from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import StyledScreen from './StyledScreen'
import Config from '../configs'
import logo from '../assets/logo.svg'

const StyledCounterPage = StyledScreen.extend`
  display: grid;
  grid-template-rows: 20vw auto 10vw;
  @media screen and (orientation:portrait) {
    grid-template-rows: 20vh auto 10vh;
  }
`
const StyledHeader = styled.div`
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const StyledTitle = styled.div`
  text-transform: uppercase;
  font-weight: 500;
  font-size: 3.77vw;
  @media screen and (orientation:portrait) {
    font-size: 3.76vh;
  }
`
const StyledBody = styled.main`
  /* border: 1px solid blue; */
  padding: 0 7.292vw;
`

const landscapeRows = Math.ceil((Config.get('TOTAL_NUMBERS') - 1) / 5)
const portraitRows = Math.ceil((Config.get('TOTAL_NUMBERS') - 1) / 3)

const StyledGrid = styled.div`
  /* border: 1px solid green; */
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
  grid-auto-flow: ${Config.get('GRID_FLOW')} dense;
  grid-template-columns: repeat(5, 20%);
  grid-template-rows: repeat(${landscapeRows}, ${100/landscapeRows}%);
  @media screen and (orientation:portrait) {
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(${portraitRows}, ${100/portraitRows}%);
  }
`
const StyledTrackingNumber = styled.div`
  /* border: 1px solid blue; */
  font-weight: 500;
  font-size: 4.49vw;

  @media screen and (orientation:portrait) {
    font-size: 4.48vh;
    margin-left: 0;
    padding-right: 0;
  }
`
const StyledServingNumber = StyledTrackingNumber.extend`
  font-weight: 500;
  font-size: 8.45vw;
  @media screen and (orientation:portrait) {
    font-size: 8.42vh;
  }
`
const StyledFooter = styled.footer`
  /* border: 1px solid green; */
  display: flex;
  align-items: center;
  justify-content: center;
`
const StyledFooterLogo = styled.div`
  background-image: url('${logo}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-width: 200.5px;
  min-height: 40px;
  width: 20.88vw;
  height: 4.16vw;
  @media screen and (orientation:portrait) {
    width: 20.88vh;
    height: 4.16vh;
  }
`

export default function CounterPage(props) {
  const {trackingNumbers} = props
  const maxTrackingNumber = Config.get('TOTAL_NUMBERS');
  const readyTrackingNumbers = _.drop(trackingNumbers)

  const _renderTrackingNumbers = () => {
    return _.times(maxTrackingNumber, (index)=> {
      const isEmpty = _.isEmpty(readyTrackingNumbers[index])
      return <StyledTrackingNumber key={`ticket_number_${index+1}`} isEmpty={isEmpty}>{isEmpty ? '---' : readyTrackingNumbers[index].ticket_number}</StyledTrackingNumber>
    })
  }

  return (
    <StyledCounterPage>
      <StyledHeader>
        <StyledTitle>Orders Ready</StyledTitle>
        <StyledServingNumber>{_.first(trackingNumbers).ticket_number}</StyledServingNumber>
      </StyledHeader>
      <StyledBody>
        <StyledGrid>
          { _renderTrackingNumbers() }
        </StyledGrid>
      </StyledBody>
      <StyledFooter>
        <StyledFooterLogo />
      </StyledFooter>
    </StyledCounterPage>
  )
}



// WEBPACK FOOTER //
// ./src/components/CounterPage.js